// extracted by mini-css-extract-plugin
module.exports = {"cell":"_2XAPac","gutter_32":"_2kYdF2","gutter_24":"_2sUj9M","gutter_16":"_2KjfSD","gutter_12":"_1dAA-j","gutter_8":"I8GcuL"};